import type { World } from '@dimforge/rapier3d-compat';
import { FIXED_DT, GRAVITY } from '../core/tuning';

/**
 * Rapier 모듈 전체의 타입.
 * `typeof import(...)`는 순수 타입 참조라 번들에 아무것도 추가하지 않는다.
 */
export type RapierModule = typeof import('@dimforge/rapier3d-compat');

let ready: Promise<RapierModule> | null = null;

/**
 * Rapier를 동적으로 불러오고 WASM을 초기화한다.
 *
 * compat 빌드는 WASM을 base64로 인라인하고 있어 번들러 설정이 필요 없는 대신
 * 모듈 자체가 2MB를 넘는다. 정적 import를 쓰면 그 전부가 초기 번들에 들어가
 * 모바일에서 첫 화면까지의 시간이 크게 늘어난다.
 * 동적 import로 별도 청크로 떼어내 첫 페인트를 막지 않게 한다.
 *
 * 여러 번 호출해도 로드와 초기화는 한 번만 일어난다.
 */
export function initPhysics(): Promise<RapierModule> {
  ready ??= import('@dimforge/rapier3d-compat').then(async (rapier) => {
    await rapier.init();
    return rapier;
  });
  return ready;
}

/**
 * 결정론을 위해 timestep을 고정한 물리 월드를 만든다.
 * timestep을 프레임 delta로 바꾸는 순간 같은 입력이 같은 결과를 내지 않게 되고,
 * 스냅샷 테스트 전략 전체가 무너진다.
 */
export function createWorld(rapier: RapierModule): World {
  const world = new rapier.World({ ...GRAVITY });
  world.timestep = FIXED_DT;
  return world;
}
